import { ReactNode, useEffect } from 'react';
import cn from 'classnames';

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  children: ReactNode;
  className?: string;
}

export const Modal = ({
  isOpen,
  closeModal,
  children,
  className,
}: ModalProps) => {
  useEffect(() => {
    const body = document.body;

    if (isOpen) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      body.style.overflow = 'hidden';

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    } else {
      body.style.overflow = '';
      body.style.paddingRight = '';
    }

    return () => {
      body.style.overflow = '';
      body.style.paddingRight = '';
    };
  }, [isOpen]);

  return (
    <div
      className={cn(
        'fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4 py-10 backdrop-blur-sm transition-opacity duration-300',
        { 'pointer-events-none opacity-0': !isOpen, 'opacity-100': isOpen },
      )}
      onClick={e => {
        if (e.target === e.currentTarget) closeModal();
      }}
    >
      <div
        className={cn(
          'w-full max-w-2xl transform rounded-lg p-0 shadow-lg transition-all duration-300 will-change-transform',
          {
            'scale-95 opacity-0': !isOpen,
            'scale-100 opacity-100': isOpen,
          },
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
};
